import { defineMessages } from 'react-intl';

export default defineMessages({
	learnByDoingDesc: {
		id: 'help-center.learn-by-doing.create-request.description',
		defaultMessage: 'Welcome to the portal! Try raising a request like your customers.',
		description: 'Description for Learn By Doing create Request component',
	},
	chooseRequestTypeHeading: {
		id: 'help-center.learn-by-doing.choose-request-type.heading',
		defaultMessage: 'Choose a request type',
		description: 'Heading for choosing a request type in Learn By Doing component',
	},
	chooseRequestTypeDesc: {
		id: 'help-center.learn-by-doing.choose-request-type.description',
		defaultMessage: 'Request types represent what your team can help customers with.',
		description:
			'The text is shown as a description below the "Choose a request type" heading in the Learn By Doing onboarding component, explaining what request types are.',
	},
	sendExampleRequestHeading: {
		id: 'help-center.learn-by-doing.send-example-request.heading',
		defaultMessage: 'Send an example request',
		description: 'Heading for sending an example request in Learn By Doing component',
	},
	sendExampleRequestDesc: {
		id: 'help-center.learn-by-doing.send-example-request.description',
		defaultMessage: 'Fill out the request details, then send it off!',
		description:
			'The text is shown as a description below the "Send an example request" heading in the Learn By Doing onboarding component, guiding the user to fill out and submit the example request form.',
	},
	requestCreatedHeading: {
		id: 'help-center.learn-by-doing.request-created.heading',
		defaultMessage: 'Manage request as an agent',
		description: 'Heading after request is created in Learn By Doing component',
	},
	requestCreatedDesc: {
		id: 'help-center.learn-by-doing.request-created.description',
		defaultMessage: 'Assign, add comments and resolve this request in your project.',
		description:
			'The text is shown as a description in the Learn By Doing component after a request is created, telling the agent to manage the request in their project.',
	},
	requestCreatedDescGalaxia: {
		id: 'help-center.learn-by-doing.request-created.description-galaxia',
		defaultMessage: 'Assign, add comments and resolve this request in your space.',
		description:
			'The text is shown as a description in the Learn By Doing component after a request is created in a Galaxia space, telling the agent to manage the request in their space.',
	},
	queuesRedirectLabel: {
		id: 'help-center.learn-by-doing.queues-redirect.label',
		defaultMessage: 'Go to agent view',
		description:
			'The text is shown on a button in the Learn By Doing component after a request is created, redirecting the agent to the queues (agent view) to manage incoming requests.',
	},
});
